import { useScheduleActivityLocale } from '../../hooks';
import { ScheduleActivityReferencePickerPlugin } from '../../types';

const ScheduleActivityCustomOptionLabel: ScheduleActivityReferencePickerPlugin['CustomOptionLabel'] =
  () => {
    const { t } = useScheduleActivityLocale();

    return t('SCHEDULE_ACTIVITIES');
  };

export default ScheduleActivityCustomOptionLabel;
